import { Link } from 'react-router-dom';

/**
 * Catch-all for unknown routes.
 *
 * Without this, React Router matched nothing and the app rendered a completely
 * blank black page — no message, no way back. That is not a hypothetical: the
 * counter QR is the acquisition path, so a mistyped or stale link drops a
 * prospective customer on an empty screen and they leave.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="pixel-corners bg-white p-8 max-w-md w-full text-center">
        <p className="font-heading text-4xl text-coral mb-3">404</p>
        <h1 className="font-heading text-sm text-coral mb-4">THIS PAGE WENT COLD</h1>
        <p className="font-body text-xs text-body-grey mb-6">
          That link doesn&apos;t point anywhere. If you scanned a code at the counter,
          ask the staff to try again — otherwise head back and keep collecting.
        </p>
        <Link
          to="/"
          className="inline-block font-heading text-xs text-primary bg-coral hover:bg-coral-hover px-4 py-3 uppercase tracking-wider"
        >
          Back to my card
        </Link>
      </div>
    </div>
  );
}
